import { render, staticRenderFns } from "./card-getpin.vue?vue&type=template&id=62991d0e&"
import script from "./card-getpin.vue?vue&type=script&lang=js&"
export * from "./card-getpin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports